<template>
  <div>
    <h1 class="text-center">{{ schema.$title }}</h1>

    <panel>
      <div class="row">
        <w-input
          class="col-12 form-group"
          placeholder="0000/0000"
          tooltip="Proszę podać rok szkolny w formacie 0000/0000"
          :model="schema.data.applicationDate"
        />

        <w-radio-list class="form-group col-12" :model="schema.data.creatorType" :values="typeOfCreator" />

        <w-input
          class="col-4"
          :model="schema.data.tenderer.peselInput"
          :disabled="schema.data.creatorType.$model === 1"
          @input="tryToGetStudent"
        />
      </div>
    </panel>

    <panel :title="schema.data.applicant.$title">
      <person
        :model="schema.data.applicant"
        :pesel-model="schema.data.applicant.pesel"
        :address-title="schema.data.applicant.address.$title"
      >
        <div class="row form-group">
          <w-input class="col-6" :model="schema.data.applicant.pesel" />

          <w-input class="col-6" :model="schema.data.applicant.phoneNumber" />
        </div>
      </person>
    </panel>

    <panel :title="schema.data.tenderer.$title">
      <div class="row form-group">
        <w-datepicker
          v-if="schema.data.tenderer.birthDate"
          class="col-4"
          :model="schema.data.tenderer.birthDate"
          :disabled="
            schema.data.creatorType.$model === 1 ||
              (!!schema.data.tenderer.peselInput.$model && schema.data.tenderer.peselInput.$model.length === 11)
          "
        />

        <yes-or-no
          v-if="schema.data.tenderer.isSixYearsOld.$model"
          class="col-4"
          :model="schema.data.tenderer.isFirstGrader"
        >
          <span v-html="schema.data.tenderer.isFirstGrader.$title" />
        </yes-or-no>
      </div>

      <div class="row form-group">
        <w-radio-list class="col-6" :model="schema.data.applicantType" :values="typeOfApplicant" />

        <w-radio-list
          class="col-6"
          :model="schema.data.tenderer.gender"
          :values="studentGenders"
          :disabled="!!schema.data.tenderer.peselInput.$model && schema.data.tenderer.peselInput.$model.length === 11"
        />
      </div>

      <person
        class="applicant"
        :model="schema.data.tenderer"
        :pesel-model="schema.data.tenderer.peselInput"
        :address-title="schema.data.tenderer.address.$title"
        :show-error="{ birthDate: true }"
        :disabled="{
          address: schema.data.creatorType.$model === 2,
          all: schema.data.creatorType.$model === 1,
          birthDate: !!schema.data.tenderer.peselInput.$model && schema.data.tenderer.peselInput.$model.length === 11
        }"
      />
    </panel>

    <school-form :school-model="schema.data.school" />

    <panel title="Proszę o przyznanie pomocy materialnej o charakterze socjalnym:">
      <slot name="deviationsOrEvents" />
    </panel>

    <panel :title="`Proszę o przyznanie ${benefitType} szkolnego w formie:`">
      <slot name="support" />
    </panel>

    <panel>
      <div class="row">
        <w-input
          class="col-4 form-group"
          tooltip="Liczba osób pozostających we wspólbym gospodarstwie domowym, której dochody (ustalono zgodnie z art. 8 ust. 3-13 ustawy z dnia 12 marca 2004r. o pomocy społecznej - Dz. U. z 2019.1507 j.t.) wskazano we wniosku."
          :model="schema.data.peopleAmount"
        />

        <w-input
          class="col-4 form-group"
          tooltip="Łącznie przez wszystkich członków rodziny wspólnie mieszkających i wspólnie gospodarujących z uczniem/słuchaczem, z miesiąca poprzedzającego złożenie wniosku lub z miesiąca składania  wnisoku w przypadku dochodu utraconego"
          :model="schema.data.totalCosts.totalCost"
        />

        <w-input class="col-4 form-group" :model="schema.data.totalCosts.amountPerPerson" :disabled="true" />
      </div>

      <income-statement />
    </panel>

    <panel v-if="isScholarship" :title="schema.data.socialAssistanceBenefits.$title">
      <yes-or-no class="form-group" :model="schema.data.socialAssistanceBenefits" title />
    </panel>

    <panel v-if="isScholarship" :title="schema.data.otherScholarship.$title">
      <yes-or-no class="form-group" :model="schema.data.otherScholarship.scholarship" />

      <div v-if="schema.data.otherScholarship.scholarship.$model">
        <w-input class="form-group" :model="schema.data.otherScholarship.scholarshipType" />

        <w-input class="form-group" :model="schema.data.otherScholarship.scholarshipFrom" />

        <w-input class="form-group" :model="schema.data.otherScholarship.scholarshipAmount" />
      </div>
    </panel>

    <panel title="Oświadczenia:">
      <div class="row form-group">
        <div class="col-12">
          <yes-or-no class="form-group" :model="schema.data.rodo">
            <span v-html="schema.data.rodo.$title" />
          </yes-or-no>
        </div>
      </div>

      <hr />

      <div class="row form-group">
        <div class="col-12">
          <span v-html="schema.data.incomeStatement.$title" />
        </div>
      </div>

      <div v-if="isScholarship" class="row form-group">
        <div class="col-12">
          <span v-html="schema.data.statementAcceptance.$title" />
        </div>
      </div>

      <div class="row form-group">
        <div class="col-12">
          <span v-html="schema.data.personalDataStatement.$title" />
        </div>
      </div>
    </panel>

    <panel :title="schema.data.bankAccountOwner.paymentType.$title">
      <w-radio-list
        class="form-group payment-type"
        :model="schema.data.bankAccountOwner.paymentType"
        :values="typesOfPayment"
        :title="''"
      />

      <w-input
        v-if="schema.$model.data.bankAccountOwner.paymentType === 2"
        :model="schema.data.bankAccountOwner.bankAccountNumber"
      />
    </panel>

    <panel
      v-if="schema.data.termPassedReason && schema._options.external.termPassed"
      :title="schema.data.termPassedReason.$title"
    >
      <div class="row form-group">
        <div class="col-12">
          <w-textarea :model="schema.data.termPassedReason" title />
        </div>
      </div>
    </panel>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Panel from '@/components/panel/Panel.vue';
import { ow003Mixin } from '@/mixins/document/ow003';
import { setSchoolDataMixin } from '@/mixins/document/setSchoolData';
import { replacePlaceholdersMixin } from '@/mixins/replacePlaceholders';
import Person from '../Person.vue';
import SchoolForm from '../SchoolForm.vue';
import IncomeStatement from '../staticComponents/IncomeStatement.vue';
import YesOrNo from '../YesOrNoRadio.vue';

// @vuese
// Formularz wzoru OW-003
export default {
  components: {
    IncomeStatement,
    Panel,
    Person,
    SchoolForm,
    YesOrNo,
    ...components
  },
  mixins: [ow003Mixin, replacePlaceholdersMixin, setSchoolDataMixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true },
    // dane ucznia
    student: { type: Object, required: false },
    // dane wnioskodawcy
    applicant: { type: Object, required: false },
    // dane szkoły
    school: { type: Object, required: false }
  },
  data() {
    return {
      tenderer: this.schema.$model.data.tenderer
    };
  },
  computed: {
    isScholarship() {
      return this.schema.$model.data.typeOfHelp === 1;
    },
    studentGenders() {
      if (this.schema.$model.data.applicantType === 1) {
        return [
          { value: 1, text: 'Uczeń' },
          { value: 2, text: 'Uczennica' }
        ];
      } else if (this.schema.$model.data.applicantType === 2) {
        return [
          { value: 1, text: 'Słuchacz' },
          { value: 2, text: 'Słuchaczka' }
        ];
      }

      return [
        { value: 1, text: 'Uczeń/Słuchacz' },
        { value: 2, text: 'Uczennica/Słuchaczka' }
      ];
    },
    schoolModel() {
      return this.schema.data.school;
    }
  },
  mounted() {
    this.loadInitialData();
  },
  methods: {
    // @vuese
    // Wczytuje pobrane dane do wniosku
    loadInitialData() {
      if (this.schema.data.loadedData.$model) {
        return;
      }

      if (this.student) {
        this.schema.data.tenderer.$setData({ ...this.student, address: this.student.address || undefined });
      }

      if (this.applicant) {
        this.schema.data.applicant.$setData({ ...this.applicant, address: this.applicant.address || undefined });
      }

      if (this.student && this.applicant && this.student.pesel === this.applicant.pesel) {
        this.schema.data.creatorType.$setData(1);
      }

      if (this.school) {
        this.updateSchoolData(this.school);
      }

      this.schema.data.loadedData.$setData(true);
    },
    // @vuese
    // Pobiera dane ucznia po peselu
    tryToGetStudent(pesel) {
      if (pesel.length === 11) {
        this.$store.dispatch('person/listForCurrentUser', { pesel }).then(result => {
          if (result?.list?.length === 1) {
            const student = result.list[0];
            this.schema.data.tenderer.$setData({ ...student, peselInput: student.pesel });
            if (student.structureUid) {
              this.$store
                .dispatch('structureNode/getByExternalUid', student.structureUid)
                .then(structure => this.updateSchoolData(structure));
            }
            if (student.address && this.schema.data.creatorType.$model === 2) {
              this.schema.data.applicant.address.$setData(student.address);
            }
          }
        });
      }
    }
  }
};
</script>

<style>
.payment-type .radio {
  display: block;
  margin-bottom: 1rem !important;
}

.applicant .datepicker input:disabled {
  background-color: #f3f3f3;
}
</style>
